import { takeLatest, call, put } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import request from '../../Utils/Request';
import { showMessageToast } from '../Login/Login.reducer';
import {
  updateInferenceStatus,
  storeInferenceDetails,
  updateFilter,
} from './Inference.reducer';

export const inferenceStop = createAction('STOP_INFERENCE');
export const fetchInference = createAction('FETCH_INFERENCE');
export const fetchLabels = createAction('FETCH_LABELS');
export const predictInference = createAction('PREDICT_INFERENCE');
export const startStreaming = createAction('START_STREAMING');
export const stopStreaming = createAction('STOP_STREAMING');

function* stopInference(action) {
  const { payload, callback } = action.payload;
  try {
    const response = yield call(
      request,
      `/rest/runtime-inference/stop?model-uuid=${payload}`,
      {
        method: 'PUT',
        action,
      }
    );
    if (response.status === 200) {
      callback();
      yield put(updateInferenceStatus('Completed'));
      yield put(
        showMessageToast({
          show: true,
          message: response.message,
          type: 'success',
        })
      );
    } else {
      throw new Error('Failed to stop inference');
    }
  } catch (error) {
    callback();
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'Failed to stop inference',
        type: 'error',
      })
    );
  }
}

function* fetchInferenceDetail(action) {
  const { data, callback } = action.payload;
  try {
    const response = yield call(request, '/rest/runtime-inference/images', {
      method: 'POST',
      data,
      action,
    });
    if (response.status === 200) {
      const { inferenceId, inferenceName, modelLearningMode } = response.entity;
      yield put(
        storeInferenceDetails({
          entity: {
            runtimeUuid: inferenceId,
            inferenceName,
            modelLearningMode,
          },
        })
      );
      yield put(updateFilter(data.filterByLabel));
      callback(response.entity);
    }
  } catch (error) {
    console.log(error);
  }
}

function* fetchLabelsDetails(action) {
  const { callback } = action.payload;
  try {
    const response = yield call(request, '/rest/labels', {
      action,
    });
    if (response.status === 200) {
      callback(response.entity);
    }
  } catch (error) {
    console.log(error);
  }
}

function* inferencePredict(action) {
  const { payload, callback } = action.payload;
  try {
    const response = yield call(request, `/rest/runtime-inference/predict`, {
      method: 'POST',
      action,
      data: payload,
    });
    if (response.status === 200) {
      console.log(response.data, 'Predict response Data');
      callback(response.status);
    }
  } catch (error) {
    console.log(error);
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'Failed to predict inference',
        type: 'error',
      })
    );
    callback();
  }
}

function* streamingStart(action) {
  const { payload } = action.payload;
  try {
    const response = yield call(
      request,
      `/rest/runtime-inference/start-streaming?model-uuid=${payload}`,
      {
        action,
      }
    );
    if (response.status === 200) {
      //
    }
  } catch (error) {
    console.log(error);
  }
}

function* streamingStop(action) {
  const { payload } = action.payload;
  try {
    const response = yield call(
      request,
      `/rest/runtime-inference/stop-streaming?model-uuid=${payload}`,
      {
        action,
      }
    );
    if (response.status === 200) {
      //
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* inferenceSaga() {
  const watcher = [];
  watcher.push(yield takeLatest(inferenceStop.toString(), stopInference));
  watcher.push(
    yield takeLatest(fetchInference.toString(), fetchInferenceDetail)
  );
  watcher.push(yield takeLatest(fetchLabels.toString(), fetchLabelsDetails));
  watcher.push(yield takeLatest(predictInference.toString(), inferencePredict));
  watcher.push(yield takeLatest(startStreaming.toString(), streamingStart));
  watcher.push(yield takeLatest(stopStreaming.toString(), streamingStop));
}
